import React from 'react'
import { isMobile } from '../../global/ScreenSizeHelper';
import AtomicButton from '../../atomic/button/AtomicButton';
import { HOME_TOPIC_ONE } from '../../global/assets/Icons';

const TopicOne = () => {


    if (isMobile) {
        return (
            <div>
                mobile TopicOne
            </div>)

    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            width: '100%',
            height: '600px',
            borderBottom: '1px solid black'
        }}>

            <div style={{
                width: '600px',
                padding: '90px 0px 0px 20px',
                flexWrap: 'wrap',
            }}>
                <div style={{
                    color: '#1B1642',
                    fontSize: '50px',
                    // fontFamily: "Playfair Display",
                    fontFamily: 'Inter Medium',
                    lineHeight: '50px',
                    fontWeight: 600,
                    flexWrap: 'wrap',
                }}>Empowering Communities with Affordable Healthy Meal Combos

                </div>
                <div style={{
                    fontFamily: 'Inter Regular', color: '#1B1642',
                    fontSize: '22px', marginTop: '20px'
                }}>“Stay full, stay healthy, and on budget with meal combos from local stores — keeping your daily food costs in check.”</div>

                <AtomicButton
                    label="Get started"
                    handleSubmit={() => { console.log('---clicked') }}
                    style={{
                        width: '325px',
                        backgroundColor: 'rgb(255, 122, 40)',
                        marginTop: '50px'

                    }}
                    loading={false}
                    disabled={false}
                />
            </div>
            <div style={{
                width: '600px',
                marginLeft: '2px',
                padding: '50px 0px 0px 20px'
            }}>
                <img alt="" src={HOME_TOPIC_ONE} width={550} style={{ marginBottom: '33px' }} ></img>
            </div>
        </div>
    )
}

export default TopicOne